module.exports = __webpack_public_path__ + "static/media/auditorium-bg.609ea2c7.jpg";